<template>
  <div class="curation-header-organization">
    <header>
      <div class="representative-image" v-if="org.image">
        <UiImageSelection :image="org.image" :fullsize="true" />
      </div>
      <BaseSectionContainer
        tag="div"
        size="middle"
      >
        <div class="jps-header-information">
          <div class="level">
            <h1 class="jps-page-title">
              {{ ls(org.name) }}
              <p class="jps-page-title-yomi" v-if="org.location">{{ org.location }}</p>
            </h1>

            <div class="jps-item-url" v-if="org.url">
              <UiButtonLinkRound
                :url="org.url"
                styled="primary"
                size="small"
              >
                {{ lss('Webサイトを開く', 'Access this website') }}
              </UiButtonLinkRound>
            </div>
          </div>

          <div class="jps-interactions">
            <UiInteractPanel
              type="organization"
              :data="org"
              class="jps-card-icon"
            />
          </div>
          <div class="jps-header-description">
            <p class="is-size-6-desktop is-size-7-touch">
              {{ ls(org.description) }}
            </p>
          </div>
        </div>
      </BaseSectionContainer>
    </header>
  </div>
</template>

<script lang="ts" setup>
const { ls, lss } = useI18n()

interface Props {
  org: Organization
}
const props = withDefaults(defineProps<Props>(), {})
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.curation-header-organization {
  @include details-header;
  @include details-header-is-light;
  .representative-image {
    height: 512px;
    width: 100%;
    .jps-image-selection {
      background: none;
    }
  }
  /*mobileの場合には16:9で固定*/
  @include is-mobile {
    .representative-image {
      height: unset;
      @include ratio16x9Wrapper;
      .jps-image-selection {
        @include ratioInner;
      }
    }
  }

  .jps-header-description {
    // @include global-width-strict();
    .jps-meta {
      margin-top: 1rem;
    }
  }

  > section {
    @include is-mobile() {
      padding: 2rem 1rem;
    }
    @include is-tablet() {
      padding: 4rem;
    }

    h2 {
      font-weight: bold;
      margin-bottom: 0.5rem;
    }
    p.description {
      margin-bottom: 1.5rem;
    }
    div.organization {
      @include is-mobile() {
        margin-top: 1rem;
      }
      @include is-tablet() {
        margin-top: 3rem;
      }
    }
    div.search {
      margin-bottom: 1rem;
    }
  }

  .info-area {
    margin-top: 1em;
    p {
      margin-left: 0.5em;
    }

    .description {
      margin-top: 1em;
    }

    .stat {
      margin-top: 1em;
    }

    .organization {
      margin-top: 1em;
    }
    .header {
      font-size: 1.2rem;
      font-weight: bold;
    }
  }
}
</style>
